var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.33317H1.5M12.3333 1.6665V4.99984M5.66667 1.6665V4.99984M6.5 13.3332L8.16667 14.9998L11.9167 11.2498M5.5 18.3332H12.5C13.9001 18.3332 14.6002 18.3332 15.135 18.0607C15.6054 17.821 15.9878 17.4386 16.2275 16.9681C16.5 16.4334 16.5 15.7333 16.5 14.3332V7.33317C16.5 5.93304 16.5 5.23297 16.2275 4.69819C15.9878 4.22779 15.6054 3.84534 15.135 3.60565C14.6002 3.33317 13.9001 3.33317 12.5 3.33317H5.5C4.09987 3.33317 3.3998 3.33317 2.86502 3.60565C2.39462 3.84534 2.01217 4.22779 1.77248 4.69819C1.5 5.23297 1.5 5.93304 1.5 7.33317V14.3332C1.5 15.7333 1.5 16.4334 1.77248 16.9681C2.01217 17.4386 2.39462 17.821 2.86502 18.0607C3.3998 18.3332 4.09987 18.3332 5.5 18.3332Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIcon);
export default __webpack_public_path__ + "static/media/appointmentIcon.8dac261cab320138da6af8b0d4e747e4.svg";
export { ForwardRef as ReactComponent };